import React, { useState } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import { TABLE_DATA,TABLE_HEADERS,keyMapping } from '../../../../../constants/LeadALlocationList';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import warmLeadICon from './../../../../../Assets/icons/warmleadimg.svg';
import hotLeadIcon from './../../../../../Assets/icons/hotleadimg.svg';
import coldLeadIcon from './../../../../../Assets/icons/coldleadimg.svg';
import './index.scss';
import ListFilters from '../../OnBoardManagement/ListFilters';
import { useNavigate } from 'react-router-dom';

const LeadAllocationList = () => {
  const [activeSection, setActiveSection] = useState('Customer');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

//   const handleSectionChange = (section) => {
//     setActiveSection(section);
//   };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

//   const renderTableData = () => {
//     let filteredData = [];
//     switch (activeSection) {
//       case 'Customer':
//         filteredData = TABLE_DATA.customers.filter(customer =>
//           Object.values(customer).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       case 'Agent':
//         filteredData = TABLE_DATA.agents.filter(agent =>
//           Object.values(agent).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       case 'Company':
//         filteredData = TABLE_DATA.companies.filter(company =>
//           Object.values(company).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       default:
//         filteredData = [];
//     }
//     return filteredData;
//   };

//   const renderTableHeaders = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return TABLE_HEADERS.customers;
//       case 'Agent':
//         return TABLE_HEADERS.agents;
//       case 'Company':
//         return TABLE_HEADERS.companies;
//       default:
//         return [];
//     }
//   };

//   const renderKeyMapping = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return keyMapping.customers;
//       case 'Agent':
//         return keyMapping.agents;
//       case 'Company':
//         return keyMapping.companies;
//       default:
//         return [];
//     }
//   };

//   const renderAddButtonLabel = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return 'Add New Customer';
//       case 'Agent':
//         return 'Add New Agent';
//       case 'Company':
//         return 'Add New Company';
//       default:
//         return 'Add New';
//     }
//   };

//   const handleAddButtonClick = () => {
//     switch (activeSection) {
//       case 'Customer':
//         navigate('/admin/manage-onboard/onboard/create-customer');
//         break;
//       case 'Agent':
//         navigate('/admin/manage-onboard/onboard/create-agent');
//         break;
//       case 'Company':
//         navigate('/admin/manage-onboard/onboard/create-company');
//         break;
//       default:
//         break;
//     }
//   };

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map(header => keyMapping[header]);
    const csvRows = data.map(item => {
      return headers.map(header => {
        const key = keyMapping[header];
        return item[key];
      }).join(',');
    });
    const csvContent = [
      csvHeaders.join(','),
      ...csvRows
    ].join('\n');
    return csvContent;
  };

  const handleDownloadClick = () => {
    const csvContent = formatDataForDownload(TABLE_DATA, TABLE_HEADERS, keyMapping);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${activeSection}_data.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className='leadmanagementContainer'>
        <div className='leadcountcontainer' >
        <h5>Lead Allocation</h5>
            <div>
            <img src={coldLeadIcon} height={50} width={150} />
            <p style={{fontSize:'12px'}}>44 Cold Leads</p>
            </div>
             <div>
             <img src={hotLeadIcon} height={50} width={150} />
             <p style={{fontSize:'12px'}}>34 Cold Leads</p>
            </div>
         
         <div>

         <img src={warmLeadICon} height={50} width={150} />
         <p style={{fontSize:'12px',display:'flex',justifyContent:'center'}}>65 Warm Leads</p>
         </div>
        
        
        </div>
        <div className='totalvaluescontainer'>
          <div className='totalvalues'>
            <h5>150</h5>
            <h6>Total Leads</h6>
          </div>
          <div className='totalvalues'>
            <h5>150</h5>
            <h6>Leads Priority</h6>
          </div>
         
          <div className='addleadbtncontainer'>
            <button className='addcustomerbutton'onClick={()=>navigate('/admin/manage-lead/lead-allocation/add-lead')}>
              Add Lead
            </button>
            <button className='addcustomerbutton' >
              Upload Lead
            </button>
          </div>
        </div>
      </div>

      <ListFilters />

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Lead Allocation List</h5>
            <input 
              type='text' 
              className='searchinput' 
              placeholder={`Search Lead`} 
              value={searchTerm} 
              onChange={handleSearchInputChange} 
            />
          </div>
          <div className='downloadiconwrapper'>
            <h6 className='downloadTitle'>Download</h6>
            <img src={downloadIcon} alt='download' onClick={handleDownloadClick} style={{ cursor: 'pointer' }} />
          </div>
        </div>

        <CustomTable data={TABLE_DATA} headers={TABLE_HEADERS} keyMapping={keyMapping} itemsPerPage={5} isAllocation={true} />
      </div>
    </div>
  );
};

export default LeadAllocationList;
